<template>
	<!-- Premium -->
	<j-card class="mb2">
		<j-accordion colorWhenClosed="bg0" :startOpen="startOpen">
			<div slot="title" class="fs4 fw7">{{ $t("premium") }}</div>
			<div class="p2" slot="body">
				<premium-info
					:pricing="componentProps.pricing"
					:productId="componentProps.productId"
					v-on="componentHandlers"
					v-bind="componentProps"
					:showButtons="showButtons"
				/>
			</div>
		</j-accordion>
	</j-card>
</template>

<script>
import JCard from "@/components/JCard"
import JAccordion from "@/components/JAccordion"
import PremiumInfo from "./PremiumInfo"

export default {
	name: "SectionPremium",
	components: {
		JCard,
		JAccordion,
		PremiumInfo
	},
	props: {
		componentProps: {
			type: Object
		},
		componentHandlers: {
			type: Object
		},
		startOpen: {
			type: Boolean,
			default: false
		},
		showButtons: {
			type: Boolean,
			required: false,
			default: true
		}
	},

	methods: {}
}
</script>
